import React from "react";
import { Box, Fab } from "@mui/material";
import { ReactComponent as ChatbotIcon } from "../../../../assets/img/chatbot.svg";

interface ChatFabProps {
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
}

const ChatFab: React.FC<ChatFabProps> = ({ isOpen, setIsOpen }) => {
    if (isOpen) return null;

    return (
        <Box
            sx={{
                position: "fixed",
                bottom: 24,
                right: 24,
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                zIndex: 1000,
            }}
        >
            {/* Bubble Text */}
            <Box
                sx={{
                    backgroundColor: "#cce7f0",
                    color: "#1e293b",
                    px: 2,
                    py: 1,
                    borderRadius: "999px",
                    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: 600,
                    fontSize: "12px",
                    cursor: "default",
                    whiteSpace: "nowrap",
                }}
            >
                Ask Me Anything
            </Box>

            <Fab
                sx={{
                    color: "white",
                    width: 60,
                    height: 60,
                    boxShadow: "0 8px 24px rgba(102, 126, 234, 0.4)",
                    "&:hover": {
                        transform: "scale(1.05)",
                    },
                }}
                onClick={() => setIsOpen(true)}
            >
                <ChatbotIcon />
            </Fab>
        </Box>
    );
};

export default ChatFab;